// config
import * as http from 'utils/http';
import config from 'config';
const PAGE_SIZE = 100;

const getFilteredCarrierUsers = async (search) => {
  const endpoint = `${config.BASE_ROUTE}api/users/?search=${search}&is_carrier=true&page_size=${PAGE_SIZE}`;
  const encodedEnpoint = encodeURI(endpoint);
  const data = await http.get(encodedEnpoint);
  return data;
};

export default getFilteredCarrierUsers;
